export default {
  state: {
    testText: 'testText666'
  },
  getters: {

  },
  mutations: {

  },
  actions: {

  }
}
